import { gql } from '@apollo/client';
import { useMutation } from '../hooks';

export const messageFields = gql`
  fragment MessageFields on Message {
    id
    sender
    subject
    sanitizedFullHtml
    sanitizedTrimmedHtml
    sentAt
    draft
    draftRevision
    draftMessageBody
    createdAt
    scheduledSendAt
    firstReadByUserAt
    clickCount
    openCount
    notDeliveredEvents
    canUndoSend
    occurredAt
    user {
      id
      fullName
    }
    toEmailAddresses {
      id
      displayName
      address
    }
    ccEmailAddresses {
      id
      displayName
      address
    }
    fromEmailAddress {
      id
      displayName
      address
      gravatarUrl
    }
    documents {
      id
      filename
      url
      byteSize
    }
  }
`;

const unreadMutation = gql`
  mutation UnreadMessage($input: UnreadMessageInput!) {
    unreadMessage(input: $input) {
      message {
        id
        firstReadByUserAt
      }
      errors {
        message
      }
    }
  }
`;

export const useUnreadMessageMutation = ({ ...config }) =>
  useMutation(unreadMutation, config);
